<template>
    <v-display :form="form" :path="path" :label="label" value="">
        <div class="row">
            <q-radio v-for="option in options"
                     :key="option.value"
                     v-model="inputValue"
                     :label="option.label"
                     :val="option.value"
                     :color="color"
                     :disable="form.busy || disable"
                     class="on-left"
                     checked-icon="check circle"
                     unchecked-icon="radio button unchecked"
                     @input="onInput"
                     :class="{ 'col-12': vertical }"></q-radio>
        </div>
    </v-display>
</template>

<script>
    import mixins from './mixins'
    import {QRadio} from 'quasar-framework'

    export default {
        name: 'VRadio',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            },
            vertical: Boolean
        },

        components: {
            QRadio
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VRadio.vue